import React from "react";

const TPAList = ({ initialdata, sectionLabel, proposalData }) => {
  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length < 6) return "-";
    const [year, month, day, hour, minute, second] = dateArray;
    const formattedDate = `${String(day).padStart(2, "0")}-${String(
      month
    ).padStart(2, "0")}-${year}`;
    const formattedTime = `${hour}:${String(minute).padStart(2, "0")}:${String(
      second
    ).padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  };
  return (
    <>
      {initialdata &&
        initialdata.map((item, i) => {
          return (
            item.show &&
            typeof item.value !== "object" &&
            item.value !== null && (
              <div className={"list_proposal "} key={i}>
                <div className="label"> {item.name}</div>
                <div className="value tpaValue">{String(item.value)}</div>
              </div>
            )
          );
        })}
      <div className={"list_proposal "}>
        <div className="label"> Created On</div>
        <div className="value tpaValue">
          {formatDate(proposalData?.tpaWaiveOffDetails?.audit?.createdOn)}
        </div>
      </div>
      <div className={"list_proposal "}>
        <div className="label"> Updated On</div>
        <div className="value tpaValue">
          {formatDate(proposalData?.tpaWaiveOffDetails?.audit?.updatedOn)}
        </div>
      </div>
    </>
  );
};

export default TPAList;
